// Libs
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
// Actions
import { sendToast } from 'screens/Dashboard/actions';
// Hooks
import useOrderApi from 'core/hooks/useCoreApi';
import {
	canEditSerializedState,
	isSerializedInventoryRow,
} from './StateItemValue.utils';
// Components
import ItemStateSelect from './ItemStateSelect';

const StateItemValue = ({ rowData, stateTable = {} }) => {
	const isSerialized = isSerializedInventoryRow(rowData);
	const { isTransactionFrozen = false, updateItemOnTable } = stateTable;
	const isMountedRef = useRef(true);
	const [state, _setState] = useState({
		selectState: null,
		isLoading: false,
		value: rowData.wtdi_amount || 0,
		isValidated: canEditSerializedState({ rowData, isTransactionFrozen }),
	});

	const { upsertArticle } = useOrderApi();
	const dispatch = useDispatch();

	const setState = newState =>
		isMountedRef.current &&
		_setState(currentState => ({ ...currentState, ...newState }));

	const handleArticleState = value => {
		setState({ isLoading: true });
		const formatValue = Number(value);

		upsertArticle({
			ids: { wtdiId: rowData.wtdi_id },
			fields: { serieId: rowData.serie, state_id: formatValue },
		})
			.then(() => {
				updateItemOnTable({ id: rowData.id }, { wtdi_amount: formatValue });
				setState({ selectState: formatValue, isLoading: false });
			})
			.catch(({ message }) => {
				setState({ isLoading: false });
				dispatch(sendToast({ message, type: 'error', duration: 2 }));
			});
	};

	useEffect(() => {
		setState({
			isValidated: canEditSerializedState({ rowData, isTransactionFrozen }),
		});
	}, [rowData.wtdi_id, isSerialized, isTransactionFrozen]);

	const itemStateOptions = stateTable.itemStateOptions || [];
	const itemStateOptionsStatus = stateTable.itemStateOptionsStatus || 'idle';
	const canEdit =
		isSerialized && state.isValidated && itemStateOptionsStatus === 'success';
	const isLoading =
		isSerialized &&
		state.isValidated &&
		(state.isLoading || itemStateOptionsStatus === 'loading');

	useEffect(
		() => () => {
			isMountedRef.current = false;
		},
		[],
	);

	return (
		<ItemStateSelect
			editable={canEdit}
			isLoading={isLoading}
			onChange={handleArticleState}
			options={itemStateOptions}
			placeholder={rowData.state_name}
			value={state.selectState}
		/>
	);
};

export default StateItemValue;
